import { BreadcrumbDiffLine } from "@ext/git/core/Diff/components/BreadcrumbDiffLine";
import { DiffLineContainer, type DiffLinePlacement } from "@ext/git/core/Diff/components/DiffLine/DiffLineContainer";
import { DiffLineMarker } from "@ext/git/core/Diff/components/DiffLine/DiffLineMarker";
import { DiffLinePopoverContent } from "@ext/git/core/Diff/components/DiffLine/DiffLinePopover";
import t from "@ext/localization/locale/translate";
import type { DiffHunk } from "@ext/VersionControl/DiffHandler/model/DiffHunk";
import { Popover, PopoverAnchor } from "@ui-kit/Popover";
import { useState } from "react";

export const BreadcrumbLine = ({ placement, hunks }: { placement: DiffLinePlacement; hunks: DiffHunk[] }) => {
	const [open, setOpen] = useState(false);
	return (
		<Popover onOpenChange={setOpen} open={open}>
			<DiffLineContainer
				interactive
				onClick={() => setOpen(true)}
				placement={placement}
				tooltipText={t("diff.type.breadcrumb")}
				type="breadcrumb"
			>
				<PopoverAnchor asChild>
					<div className="h-[inherit] w-full">
						<DiffLineMarker height={placement.height} type="breadcrumb" />
					</div>
				</PopoverAnchor>
			</DiffLineContainer>
			<DiffLinePopoverContent
				onInteractOutside={(event) => {
					if ((event.target as HTMLElement | null)?.closest(".comment-block")) event.preventDefault();
				}}
			>
				<BreadcrumbDiffLine changes={hunks} />
			</DiffLinePopoverContent>
		</Popover>
	);
};
